import {appConfig} from './app/app.config';
import {AppComponent, AppComponentHomepage} from './app/app.component';
import {createOkpApplication, registerOkpCustomElement} from "@okp/ng-api";

createOkpApplication(appConfig)
  .then((appRef) => {
      const appName = 'oekosystem-immosuche-ui';
      if (!customElements.get(appName)) {
        registerOkpCustomElement(appRef, { tag: appName, component: AppComponent });
        registerOkpCustomElement(appRef, { tag: 'oekosystem-immosuche', component: AppComponentHomepage });
      }
    }
  ).catch((err) => console.error(err))
